

























import { Component, Prop, Watch } from 'vue-property-decorator';
import { ProductDto } from '@eurogast/hub-client-typescript';
import { LinkUtil } from '@/services/LinkUtil';
import { namespace } from 'vuex-class';
import { CART } from '@/store/types';
import ProductDtoComponentBase from '@/common/ProductDtoComponentBase';
import { Cart, CartItem } from '@/services/cart/model/cart';
import { DependencyService } from '@/services/DependencyService';
import MatomoEvents from '@/matomo/events/MatomoEvents';

const cart = namespace(CART);

@Component
export default class PromotedProductCartItem extends ProductDtoComponentBase {
  @cart.State('cart')
  public cart: Cart;
  @Prop({required: true})
  public product!: ProductDto;
  public deletePending = false;
  public inCart = false;
  public cartItem: CartItem;

  private cartService = DependencyService.getCartService();

  get currentAmount(): number {
    return 1;
  }

  get detailUrl(): string {
    return LinkUtil.getProductDetailUrl(this.product.name, this.product.sku);
  }

  public defaultCartItem(): CartItem {
    const unit = this.product.units.find((u) => u.isDefault);
    return CartItem.buildWithUnit(
        this.product.sku,
        1,
        unit
    );
  }

  public addToCart() {
    MatomoEvents.forPromoted.addItem.publish();
    this.cartService.putItem(this.cartItem);
  }

  public removeFromCart() {
    if (this.inCart && !this.deletePending) {
      this.deletePending = true;
      MatomoEvents.forPromoted.removeItem.publish();
      this.cartService.removeItem(this.cartItem);
    }
  }

  @Watch('cart')
  public onCartChange() {
    if (!this.cart) {
      return;
    }
    const existingItem = this.cartService.getItem(this.product.sku);
    if (existingItem) {
      this.cartItem = existingItem;
      this.inCart = true; // set last to avoid change handlers saving the item
    } else {
      this.cartItem = this.defaultCartItem();
      this.deletePending = false;
      this.inCart = false;
    }
  }

  public mounted() {
    this.onCartChange();
    super.mounted();
  }

}
